// Mock data for Call Campaigns

export const mockAgents = [
  { id: 'agent_001', name: 'Collection Agent', voice: 'alloy', language: 'es-MX' },
  { id: 'agent_002', name: 'Customer Service', voice: 'nova', language: 'en-US' },
  { id: 'agent_003', name: 'Survey Agent', voice: 'shimmer', language: 'es-ES' },
];

export const mockCallerIds = [
  { id: 'caller_001', number: '+1 (555) 123-4567', label: 'Main Line' },
  { id: 'caller_002', number: '+1 (555) 987-6543', label: 'Support Line' },
  { id: 'caller_003', number: '+52 (55) 1234-5678', label: 'Mexico City' },
];

export const mockCampaigns = [
  {
    id: 'camp_001',
    name: 'Q1 Collection Campaign',
    description: 'First quarter debt collection outreach',
    agentId: 'agent_001',
    agentName: 'Collection Agent',
    callerId: '+1 (555) 123-4567',
    status: 'running',
    totalContacts: 1000,
    callsPlaced: 456,
    callsConnected: 312,
    callsVoicemail: 89,
    callsNoAnswer: 40,
    callsFailed: 15,
    avgDuration: 185,
    concurrency: 5,
    callsPerMinute: 10,
    scheduledStart: null,
    startedAt: '2025-02-04T09:00:00Z',
    createdAt: '2025-02-03T14:30:00Z',
    updatedAt: '2025-02-04T15:45:00Z',
  },
  {
    id: 'camp_002',
    name: 'Customer Satisfaction Survey',
    description: 'Post-purchase satisfaction survey Q1',
    agentId: 'agent_003',
    agentName: 'Survey Agent',
    callerId: '+52 (55) 1234-5678',
    status: 'completed',
    totalContacts: 500,
    callsPlaced: 500,
    callsConnected: 423,
    callsVoicemail: 45,
    callsNoAnswer: 22,
    callsFailed: 10,
    avgDuration: 145,
    concurrency: 3,
    callsPerMinute: 5,
    scheduledStart: null,
    startedAt: '2025-01-28T10:00:00Z',
    completedAt: '2025-01-29T16:30:00Z',
    createdAt: '2025-01-27T11:00:00Z',
    updatedAt: '2025-01-29T16:30:00Z',
  },
  {
    id: 'camp_003',
    name: 'Payment Reminder February',
    description: 'Monthly payment reminder calls',
    agentId: 'agent_001',
    agentName: 'Collection Agent',
    callerId: '+1 (555) 123-4567',
    status: 'scheduled',
    totalContacts: 750,
    callsPlaced: 0,
    callsConnected: 0,
    callsVoicemail: 0,
    callsNoAnswer: 0,
    callsFailed: 0,
    avgDuration: 0,
    concurrency: 4,
    callsPerMinute: 8,
    scheduledStart: '2025-02-10T09:00:00Z',
    startedAt: null,
    createdAt: '2025-02-04T10:00:00Z',
    updatedAt: '2025-02-04T10:00:00Z',
  },
  {
    id: 'camp_004',
    name: 'Overdue Accounts Outreach',
    description: 'Contact customers with 60+ days overdue',
    agentId: 'agent_001',
    agentName: 'Collection Agent',
    callerId: '+1 (555) 987-6543',
    status: 'paused',
    totalContacts: 200,
    callsPlaced: 87,
    callsConnected: 62,
    callsVoicemail: 15,
    callsNoAnswer: 8,
    callsFailed: 2,
    avgDuration: 210,
    concurrency: 2,
    callsPerMinute: 4,
    scheduledStart: null,
    startedAt: '2025-02-04T14:00:00Z',
    pausedAt: '2025-02-04T15:30:00Z',
    createdAt: '2025-02-04T13:00:00Z',
    updatedAt: '2025-02-04T15:30:00Z',
  },
  {
    id: 'camp_005',
    name: 'Test Campaign Draft',
    description: 'Testing new script before launch',
    agentId: 'agent_002',
    agentName: 'Customer Service',
    callerId: '+1 (555) 123-4567',
    status: 'draft',
    totalContacts: 50,
    callsPlaced: 0,
    callsConnected: 0,
    callsVoicemail: 0,
    callsNoAnswer: 0,
    callsFailed: 0,
    avgDuration: 0,
    concurrency: 1,
    callsPerMinute: 2,
    scheduledStart: null,
    startedAt: null,
    createdAt: '2025-02-04T16:00:00Z',
    updatedAt: '2025-02-04T16:00:00Z',
  },
  {
    id: 'camp_006',
    name: 'Failed Import Campaign',
    description: 'Campaign with import errors',
    agentId: 'agent_001',
    agentName: 'Collection Agent',
    callerId: '+1 (555) 123-4567',
    status: 'failed',
    totalContacts: 100,
    callsPlaced: 12,
    callsConnected: 8,
    callsVoicemail: 2,
    callsNoAnswer: 1,
    callsFailed: 1,
    avgDuration: 95,
    concurrency: 2,
    callsPerMinute: 4,
    scheduledStart: null,
    startedAt: '2025-02-02T11:00:00Z',
    failedAt: '2025-02-02T11:15:00Z',
    errorMessage: 'Rate limit exceeded. Campaign stopped.',
    createdAt: '2025-02-02T10:30:00Z',
    updatedAt: '2025-02-02T11:15:00Z',
  },
];

// Status configuration for UI
export const campaignStatuses = {
  draft: { labelKey: 'campaignStatuses.draft', color: 'bg-secondary text-foreground', icon: 'DocumentIcon' },
  scheduled: { labelKey: 'campaignStatuses.scheduled', color: 'bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400', icon: 'CalendarIcon' },
  running: { labelKey: 'campaignStatuses.running', color: 'bg-green-100 text-green-700 dark:bg-green-500/15 dark:text-green-400', icon: 'PlayIcon', pulse: true },
  paused: { labelKey: 'campaignStatuses.paused', color: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-500/15 dark:text-yellow-400', icon: 'PauseIcon' },
  completed: { labelKey: 'campaignStatuses.completed', color: 'bg-purple-100 text-purple-700 dark:bg-purple-500/15 dark:text-purple-400', icon: 'CheckCircleIcon' },
  failed: { labelKey: 'campaignStatuses.failed', color: 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400', icon: 'ExclamationCircleIcon' },
  // Read-time display status (backend `display_status`): the campaign "finished"
  // but its only terminal contacts were crm_dial_whitelist pilot skips (real leads
  // NEVER dialed). Shown instead of "Completada" so the team does not assume the
  // leads were called (fix-campaign-skipped-pilot-labels-sep3).
  piloto: { labelKey: 'campaignStatuses.piloto', color: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-500/15 dark:text-indigo-400', icon: 'BeakerIcon' },
};

// Helper to get a campaign by ID
export const getCampaignById = (id) => mockCampaigns.find(c => c.id === id);

// Helper to filter campaigns
export const filterCampaigns = (campaigns, { status, search }) => {
  return campaigns.filter(campaign => {
    if (status && status !== 'all' && campaign.status !== status) return false;
    if (search && !campaign.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
};
